import type { WavesChart } from '../wavesChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_VOID } from '../builtinPulseMaps/palettes.js';
import { assembleWavesChartFromCircles } from './wavesFromCircles.js';
import audioOnsets from '../circlesBuiltinMaps/audio/invincible.onsets.json' with { type: 'json' };
import normalImported from '../circlesBuiltinMaps/imported/invincible-normal.circles.json' with { type: 'json' };
import hardImported from '../circlesBuiltinMaps/imported/invincible-hard.circles.json' with { type: 'json' };
import extremeImported from '../circlesBuiltinMaps/imported/invincible-extreme.circles.json' with { type: 'json' };

export const INVINCIBLE_WAVES_VARIANTS: Record<Variant, WavesChart> = assembleWavesChartFromCircles({
  baseSlug: 'invincible',
  baseTitle: "Invincible",
  description: "DEAF KEV's 174 BPM hands-up DnB classic. The OG NCS dance banger, top-tier wave challenge.",
  difficulty: 5,
  palette: PALETTE_VOID,
  audioSrc: '/audio/waves/invincible.mp3',
  attribution: "\"Invincible\" by DEAF KEV [NCS Release] - https://ncs.io/invincible",
  mapper: "nik_k",
  anchorOnsets: audioOnsets,
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
  timing: {
    normal: { bpm: 203, offsetMs: 0, totalBeats: 206 },
    hard: { bpm: 203, offsetMs: 0, totalBeats: 206 },
    extreme: { bpm: 203, offsetMs: 0, totalBeats: 206 },
  },
});
